import React from 'react';

/**
 * Page representing an agent's pending.
 */
export const Pending = () => {
  return (
    <div>
      <h2>Pending</h2>
    </div>
  );
};
